var Visitor = function() {
    return {
        init: function() {
            $('.ii__genderpref').click(function() {
                $('#criteria').show();
                $('#alert_msg').hide();
                $('#gender_btn').removeClass('error');
                $('#gender_seeking_btn').removeClass('error');
                var other = '#gender';
                if ($(this).data('field') == 'gender') {
                    other = '#gender_seeking';
                }
                if ($(this).data('selection') == 'male') {
                    $(other).data('selected', 'female');
                    $(other).html('ΓΥΝΑΙΚΑ');
                } else if ($(this).data('selection') == 'female') {
                    $(other).data('selected', 'male');
                    $(other).html('ΑΝΔΡΑ');
                }
            });

            if ($('#age_slider').length && $('#gender').length) {
                Profile.initSliders();
                Profile.initPrefHandlers();
            }
            $('#start_blindchat').on('click', function() {
                var gender = $('#gender').data('selected');
                var gender_seeking = $('#gender_seeking').data('selected');
                if (gender == '' || gender_seeking == '') {
                    $('#alert_msg').show();
                    $('#gender_btn').addClass('error');
                    $('#gender_seeking_btn').addClass('error');
                    return;
                }

                var url_params = 'me=' + gender + '&seeking=' + gender_seeking;

                if (Profile.criteriaActive()) {
                    if ($('#age').data('age') != '') {
                        url_params += '&age=' + $('#age').data('age');
                    }
                    if ($('#seeking_age_from').data('age') != '' &&
                        $('#seeking_age_to').data('age') != ''
                    ) {
                        url_params += '&seeking_age_from=' + $('#seeking_age_from').data('age');
                        url_params += '&seeking_age_to=' + $('#seeking_age_to').data('age');
                    }
                    if ($('#area').data('selected') != '') {
                        url_params += '&lk_area_id=' + $('#area').data('selected');
                    }
                }
                if ($('#blindchat_form').data('aid') != '') {
                    url_params += '&aid=' + $('#blindchat_form').data('aid');
                }
                window.top.location.href = '/chat?' + encodeURI(url_params);
            });
        }
    };
}();
